module.exports = __webpack_public_path__ + "static/media/p12.bfd366fe.jpeg";